var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.display)?_c('div',{class:`uk-alert-${ _vm.type } uk-animation-fade`,attrs:{"uk-alert":""}},[(_vm.icon)?_c('span',{attrs:{"uk-icon":"warning"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.message)+" "),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }